import React from 'react';
import ModalForm from '../Modal/ModalForm';
import InputsSection from '../Modal/InputsSectionColumn';
import InputBoxSkeleton from './InputBoxSkeleton';
import ModalButtonsSkeleton from './ModalButtonsSkeleton';

const ResetPasswordSkeleton = () => {
	return (
		<ModalForm style={{ marginBottom: '2.5rem' }}>
			<InputsSection>
				<InputBoxSkeleton />
				<InputBoxSkeleton />
			</InputsSection>
			<ModalButtonsSkeleton />
		</ModalForm>
	);
};

export default ResetPasswordSkeleton;
